import { IFilterWithValues } from "../../List/components/FilterModal";

/** URL query param used to persist the active drill-down filters. */
export const ANALYTICS_FILTER_PARAM_KEY = "analytics_filter";

/**
 * Merge an incoming filter into the current active filters. When a filter for
 * the same key already exists it is replaced (e.g. re-drilling on seniority
 * swaps the previous seniority value).
 */
export const addOrReplaceFilter = (
	current: IFilterWithValues,
	incoming: IFilterWithValues
): IFilterWithValues => {
	return { ...current, ...incoming };
};

/** Remove the filter stored under `key` from the active filters. */
export const removeFilter = (current: IFilterWithValues, key: string): IFilterWithValues => {
	if (!(key in current)) {
		return current;
	}

	const next = { ...current };

	delete next[key];

	return next;
};

/**
 * Serialize the active filters into a URL-safe string, or `null` when empty.
 * The shape intentionally matches the Contacts `contacts_filter` param so the
 * payload can be re-used directly.
 */
export const serializeFilters = (filters: IFilterWithValues): string | null => {
	if (!filters || Object.keys(filters).length === 0) {
		return null;
	}

	return JSON.stringify(filters);
};

/**
 * Parse the `analytics_filter` URL value into an `IFilterWithValues`. Returns
 * an empty object on missing or malformed input (we never throw from a URL).
 */
export const parseFilters = (value: string | null | undefined): IFilterWithValues => {
	if (!value) {
		return {};
	}

	try {
		const parsed = JSON.parse(value);

		if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
			return parsed as IFilterWithValues;
		}

		return {};
	} catch {
		return {};
	}
};
